/**
 * objectFirstKeyFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function objectFirstKeyFilter() {
    return object => {
        if (!angular.isObject(object)) {
            return null;
        }

        const keys = Object.keys(object);

        return keys.length ? keys[0] : null;
    };
}
